module.exports = __webpack_public_path__ + "static/media/img-algo-it.21a2b588.png";